import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextCard from './TextCard';
import TextCardBold from './TextCardBold';
import { useTheme } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import PanelLine from './PanelLine';



export default function PathoCardAccordion({condition, mondo_id, mondo, genes_id, genes, variants_id, variants, hit_id, hits, trafficlight, trafficlight_panel, icon_1 }) {

  const theme = useTheme();
  
    return (

theme.palette.mode === "light" ? (

  <Box sx={{mb:2.5}}>
      <Accordion elevation={3} sx={{mb:2, bgcolor: 'grey.C200', }}>     
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
           <PanelLine 
                marker= {<TextCardBold textcard={condition} />}
                icon_1 = {icon_1} 
           /> 
        </AccordionSummary> 
     
        <AccordionDetails sx={{}}>
      <Grid container spacing={1} sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',  borderRadius: '10px', border: 'groove', }}> 
                   
          
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={mondo_id} /> </Grid> 
          <Grid size={8}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>   <TextCard textcard={mondo} /> </Grid> 
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={genes_id} /> </Grid> 
          <Grid size={8}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={genes} /> </Grid> 
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',}}>  <TextCard textcard={variants_id} /> </Grid> 
          <Grid size={8}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',}}>  <TextCard textcard={variants} /> </Grid> 
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start'}}>  <TextCard textcard={hit_id} /> </Grid> 
          <Grid size={8} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',}}> <TextCard textcard= {hits} /> </Grid>
          
      
      </Grid>   
    </AccordionDetails>
</Accordion>
</Box>

) : (

<Box sx={{mb:2}}>
<Accordion elevation={3} sx={{mb:2, bgcolor: 'greydark.C500', }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header"  >
           <PanelLine 
                marker={condition} 
                icon_1 = {icon_1} 
           /> 
        </AccordionSummary> 
     
    <AccordionDetails sx={{}}>
      <Grid container sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  borderRadius: '10px', border: 'groove', }}> 
                   
          
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={mondo_id} /> </Grid> 
          <Grid size={8}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>   <TextCard textcard={mondo} />    </Grid> 
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={genes_id} />  </Grid> 
          <Grid size={8}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={genes} />     </Grid> 
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',}}>  <TextCard textcard={variants_id} /> </Grid> 
          <Grid size={8}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',}}>  <TextCard textcard={variants} />  </Grid> 
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',}}>  <TextCard textcard={hit_id} />    </Grid> 
          <Grid size={8} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',}}>  <TextCard textcard={hits} />       </Grid>
          
      
      </Grid>   
    </AccordionDetails>
</Accordion>

  </Box>

    )
  )
  }